export default class RuleComponent {
  constructor() {
    this.floatInfo = window.baseInfo.float_info || {}

    this.renderBtn()
    this.renderModel()
    setTimeout(() => {
      this.$model = document.querySelector('#js-rule-common-model-up-outer')
      this.listenEvents()
    }, 50)
  }

  renderBtn() {
    const $btn = document.querySelector('#js-rule-wrap')
    if ($btn && +this.floatInfo.status === 1) {
      $btn.textContent = this.floatInfo.title || '活动规则'
      $btn.style.opacity = 1
      $btn.style.zIndex = 99
    }
  }

  renderModel() {
    const $tpl = `
      <div class="common-model-up-outer hide" id="js-rule-common-model-up-outer">
        <div class="common-model-up-mask"></div>
        <div class="common-model-up">
          <div class="common-model-up-container auto-height">
            <div class="common-model-up-title">活动规则</div>
            <div class="_content">${this.floatInfo.content}</div>
            <div class="common-model-up-btns">
              <div class="common-model-up-btns-container">
                <div class="common-model-up-btn">
                  <div class="common-model-up-btn-label know-btn">我知道了</div>
                </div>
              </div>
            </div>
            <div class="common-model-up-close-btn"></div>
          </div>
        </div>
      </div>
    `
    document.body.insertAdjacentHTML('beforeend', $tpl)
  }

  showModel() {
    this.$model.classList.remove('hide')
  }

  hideModel() {
    this.$model.classList.add('hide')
  }

  listenEvents() {
    // 点击“活动规则”打开弹窗
    const $ruleBtn = document.querySelector('#js-rule-wrap')
    $ruleBtn &&
      $ruleBtn.addEventListener('click', () => {
        this.showModel()
      })

    // 点击蒙层关闭弹窗
    const $up = this.$model.querySelector('.common-model-up')
    $up &&
      $up.addEventListener('click', () => {
        this.hideModel()
      })

    // 关闭弹窗
    const $closeBtn = this.$model.querySelector('.common-model-up-close-btn')
    $closeBtn &&
      $closeBtn.addEventListener('click', event => {
        event.stopPropagation()
        this.hideModel()
      })

    // 我知道了
    const $knowBtn = this.$model.querySelector('.know-btn')
    $knowBtn &&
      $knowBtn.addEventListener('click', event => {
        event.stopPropagation()
        this.hideModel()
      })
  }
}



// WEBPACK FOOTER //
// ./src/pages/promotion/template/js/RuleComponent.js